import { LitElement, html } from "lit";

import { customElement } from "lit/decorators.js";

import { groupButtonStyles } from "./group-button.css";

@customElement("group-button")
export class GroupButton extends LitElement {
  static override styles = [groupButtonStyles];

  override render() {
    return html`
      <div class="group-container">
        <slot></slot>
      </div>
    `;
  }
}
